import axios from "axios";
const API = process.env.REACT_APP_MICRO_SMART_URL;
const VERSION = process.env.REACT_APP_MICRO_SMART_URL_API;
import { handleSuccessOne } from "@store/action/GlobalAction";
const radio_id = localStorage.getItem("radio_id");

export const getCommentByWebmaster = (webmasterTitle, params) => (dispatch) => {
  axios
    .get(`${API}${VERSION}/${webmasterTitle}/comment`, {
      params,
    })
    .then((response) => {
      dispatch({
        type: "GET_COMMENT_BY_WEB",
        data: response.data.data,
        allData: response.data.data.data,
        totalPages: response.data.data.total,
        params,
      });
    });
};
export const getCommentByTopic = (PATH, params) => (dispatch) => {
  axios.get(`${API}${VERSION}${PATH}`, { params }).then((response) => {
    dispatch({
      type: "GET_COMMENT_BY_TOPIC",
      data: response.data.data.data,
      allData: response.data.data.data,
      totalPages: response.data.data.total,
      params,
    });
  });
};

export const getCommentByBlog = (myURL, id, params) => (dispatch) => {
  axios
    .get(`${API}${VERSION}${myURL}/comment/?topicId=${id}`, { params })
    .then((response) => {
      dispatch({
        type: "GET_COMMENT_BY_BLOG",
        data: response.data.data,
        allData: response.data.data,
        totalPages: response.data.data.total,
        params,
      });
    });
};

export const addCommentByBlog = (myURL, data, topic_id, func) => (dispatch) => {
  axios
    .post(`${API}${VERSION}${myURL}/comment`, data)
    .then((res) => {
      dispatch({
        type: "ADD_COMMENT_SUCCESS",
        payload: res.data,
      });
      func();
      handleSuccessOne(res.data.message);
      dispatch(getCommentByBlog(myURL, topic_id));
    })
    .catch((err) => {
      if (err.response) {
        dispatch({
          type: "ADD_COMMENT_FAIL",
          payload: err.response.data.message,
        });
        setTimeout(() => {
          dispatch({
            type: "ADD_COMMENT_FAIL",
            payload: null,
          });
        }, 3000);
      }
    });
};
export const editCommentById = (commentId, data, params) => (dispatch) => {
  axios
    .put(
      `${API}${VERSION}/comment/${commentId}?name=${data.name}&email=${data.email}&comment=${data.comment}&user_id=${data.user_id}&status=${data.status}`
    )
    .then((res) => {
      dispatch({
        type: "EDIT_COMMENT_SUCCESS",
      });
      dispatch(
        getCommentByWebmaster(params.theWebmasterTitle, {
          page: params.page,
          per_page: params.per_page,
        })
      );
    })
    .catch((err) => {});
};
